var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "填写退款信息",
            visible: _vm.dialogVisible,
            "show-close": false,
            "close-on-click-modal": false,
            "before-close": () => (_vm._dialogVisible = false),
            "modal-append-to-body": false,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "listForm",
              attrs: {
                model: _vm.listParams,
                rules: _vm.checkListParams,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticClass: "row-bg",
                  attrs: { type: "flex", justify: "space-between" },
                },
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号：", prop: "orderId" } },
                        [_c("span", [_vm._v(_vm._s(_vm.orderItem.orderNo))])]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "原订单核销总金额:",
                            "label-width": "250px",
                            prop: "orderId",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.orderItem.amountTotal)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.goodLoading,
                          expression: "goodLoading",
                        },
                      ],
                      attrs: { data: _vm.tableData, border: "" },
                      on: { "selection-change": _vm.handleSelectionChange },
                    },
                    [
                      _c("el-table-column", { attrs: { type: "selection" } }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "商品",
                          prop: "productTitle",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("img", {
                                  staticStyle: {
                                    width: "100px",
                                    height: "100px",
                                  },
                                  attrs: { src: row.productPicture, alt: "" },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "商品名称",
                          prop: "productTitle",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "商品单价",
                          prop: "productPrice",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "商品规格",
                          prop: "productSpec",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(row.productSpecWeight) +
                                    "/" +
                                    _vm._s(row.productSpec) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "商品数量",
                          prop: "productQuantity",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "商品定金",
                          prop: "discountPrice",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "核销金额",
                          prop: "tradeAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { title: "退款后订单合计" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "商品数量 " } },
                    [_vm._v(_vm._s(_vm.checkedList.length))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "商品定金" } }, [
                    _vm._v(_vm._s(_vm.discountPrice)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "商品核销总金额" } },
                    [_vm._v(_vm._s(_vm.amountTotal))]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退款原因：", prop: "refundType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择退款原因" },
                      model: {
                        value: _vm.listParams.refundType,
                        callback: function ($$v) {
                          _vm.$set(_vm.listParams, "refundType", $$v)
                        },
                        expression: "listParams.refundType",
                      },
                    },
                    _vm._l(_vm.reasonList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "原因补充：", prop: "reason" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入原因补充" },
                    model: {
                      value: _vm.listParams.reason,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.listParams,
                          "reason",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "listParams.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm._dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.submitLoading,
                    loading: _vm.submitLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onClickSubmit("listForm")
                    },
                  },
                },
                [_vm._v(" 确 定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }